import { InputType } from "../../types/input.ts";

interface props {
    label: string;
    type: InputType;
    name: string;
    value: string | number;
    onInputChange: Function;
    placeholder?: string;
    className?: string;
}

const FormInput = ({
    label,
    name,
    value,
    type,
    onInputChange,
    placeholder = "",
    className
}: props) => {
    return (
        <label className={"flex flex-col"}>
            <span className={"ml-0"}>{label}</span>
            <input
                type={type}
                name={name}
                value={value}
                placeholder={placeholder}
                className={`appearance-none bg-neutral-500 rounded-full text-white border border-neutral-700 px-3 py-1 mt-2 ring-2 ring-offset-2 ring-transparent focus:ring-[#008DD2] ring-offset-neutral-700 outline-hidden transition-all ${className}`}
                onInput={(e) => onInputChange(e)}
            />
        </label>
    );
};

export default FormInput;
